var exports = {
  "jI": "ShowcaseSection__udK1eB",
  "AY": "ShowcaseSection__gridFrame__pxIkBe",
  "qB": "ShowcaseSection__gridContent__UHFJWr",
  "dD": "ShowcaseSection__gridColumn__7obfgj",
  "VW": "ShowcaseSection__Spacer__8iTcsZ",
};

module.exports = exports;
